import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  CircularProgress,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  FormHelperText,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Chip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { post } from "../../../../src/services/http";
import { ContextSession } from "../../../services/ContextSession";
import FilterListIcon from "@mui/icons-material/FilterList";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import CryptoJS from "crypto-js";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HandymanIcon from "@mui/icons-material/Handyman";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  exportConstanciasToExcel,
  fetchUsuariosSecretariaGeneral,
  shouldIncludeApprovedBy,
} from "./exportConstanciasExcel";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none", // Elimina la línea vertical entre columnas
    borderLeft: "none", // Elimina la línea vertical entre columnas
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    // Agrega estilo al pasar el cursor sobre la fila
    backgroundColor: "#C1C1C1", // Cambia el color de fondo al pasar el cursor
  },
}));

function ListaSolConstanciasSG() {
  let sessi = useContext(ContextSession);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [loanType, setLoanType] = useState("");
  const [statusFilter, setStatusFilter] = useState("6");
  const [searchDNI, setSearchDNI] = useState("");
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [usuariosSG, setUsuariosSG] = useState([]);
  const estadosConstancia = {
    1: "PENDIENTE DE PAGO",
    2: "PAGADA",
    3: "CANCELADA",
    4: "EMITIDA",
    5: "ANULADA",
    6: "REVISANDO",
  };

  const tiposConstancia = {
    1: "HISTORIAL DE COTIZACIONES",
    2: "RAZONADA",
    3: "SALDOS PROYECTADOS",
    4: "NO TENER PRÉSTAMO ACTIVO",
    5: "TRÁMITE EMBAJADA",
  };

  // const dominio = "http://172.20.7.10:8082";
  const dominio = "https://be.injupemp.gob.hn:8443";
  //const dominio = "http://127.0.0.1:8000";

  // NUEVO: estados para dialog y fila seleccionada
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [patchLoading, setPatchLoading] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openDialogSubsanar, setOpenDialogSubsanar] = useState(false);
  const [openSuccessDialogSubsanar, setOpenSuccessDialogSubsanar] =
    useState(false);
  const [observacionFiltro, setObservacionFiltro] = useState("");
  const [observacion, setObservacion] = useState("");
  const [camposSeleccionados, setCamposSeleccionados] = useState({
    copiaDNI: false,
    copiaConstancia: false,
  });
  const [errorObservacion, setErrorObservacion] = useState(false);
  const [errorDocumentos, setErrorDocumentos] = useState(false);
  const [formValido, setFormValido] = useState(false);

  const [openDialogRechazar, setOpenDialogRechazar] = useState(false);
  const [openSuccessDialogRechazar, setOpenSuccessDialogRechazar] =
    useState(false);

  useEffect(() => {
    const documentosValidos =
      camposSeleccionados.copiaDNI || camposSeleccionados.copiaConstancia;
    const observacionValida = observacion.trim().length > 0;

    setErrorDocumentos(!documentosValidos);
    setErrorObservacion(!observacionValida);
    setFormValido(documentosValidos && observacionValida);
  }, [camposSeleccionados, observacion]);

  // 1. Mueve fetchData fuera de useEffect
  const fetchData = async () => {
    setLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const queryString = `IdEstado=${statusFilter}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex,
      );

      //const response = await fetch(`https://be.injupemp.gob.hn:8443/api/ConstanciaPag/ConstanciaSG/?IdEstado=${statusFilter}`, {
      const response = await fetch(
        // `http://172.20.7.10:8082/api/ConstanciaPag/ConstanciaSG/?IdEstado=${statusFilter}`,
        `${dominio}/api/ConstanciaPag/ConstanciaSG/?IdEstado=${statusFilter}`,
        {
          method: "GET",
          headers: {
            "X-Signature": signature,
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) throw new Error("Error al obtener los datos");
      const data = await response.json();
      setRows(data);
    } catch (error) {
      setRows([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [statusFilter]);

  useEffect(() => {
    const fetchUsuariosSG = async () => {
      const data = await fetchUsuariosSecretariaGeneral();
      setUsuariosSG(data);
    };

    fetchUsuariosSG();
  }, []);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const filteredRows = rows.filter((row) => {
    const selectedStatus = Number(statusFilter);
    const rowStatus = Number(row.fk_id_estado);
    const meetsInitialCriteria =
      selectedStatus === 6
        ? rowStatus === 6 && row.secretariaGeneralAprobado === null
        : rowStatus === selectedStatus;

    // Si hay búsqueda por DNI, aplica el filtro adicional
    if (searchDNI.trim() !== "") {
      // Asegúrate de que row.dniSolicitante existe y coincide con la búsqueda
      const dniMatch =
        row.DNI_usuario &&
        row.DNI_usuario.toString()
          .toLowerCase()
          .includes(searchDNI.toLowerCase());

      return meetsInitialCriteria && dniMatch;
    }

    return meetsInitialCriteria;
  });

  const handleDownloadExcel = () => {
    exportConstanciasToExcel({
      rows: filteredRows,
      bandeja: estadosConstancia[Number(statusFilter)] || "Constancias",
      tiposConstancia,
      estadosConstancia,
      includeAprobadoPor: shouldIncludeApprovedBy(statusFilter),
      usuariosSG,
    });
  };

  // --- Función para abrir el dialog ---
  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setObservacionFiltro(row?.Observacion_filtro || "");
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setObservacionFiltro("");
  };

  // 2. PATCH y dialog de éxito
  const handleAccept = async () => {
    if (!selectedRow) return;
    setPatchLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      const idUser = sessi.sessionData.id;
      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex,
      );
      //const url = `http://172.20.7.10:8082/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;
      const url = `${dominio}/api/ConstanciaPag/ConstanciaSG/Aprobar/?IdSolicitud=${idSolicitud}&IdUserSG=${idUser}`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ObservacionFiltro: observacionFiltro,
        }),
      });

      if (!response.ok) throw new Error("Error al aprobar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      handleCloseDialog();
      setOpenSuccessDialog(true);
    } catch (error) {
      alert("Ocurrió un error al aprobar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
    setObservacionFiltro("");
    fetchData();
  };

  ////////////////////////////////////////////////////////////////////////////////////// SUBSANAR

  const handleOpenDialogSubsanar = (row) => {
    setSelectedRow(row);
    setOpenDialogSubsanar(true);
  };

  // 2. PATCH y dialog de SUBSANAR
  const handleAcceptSubsanar = async () => {
    if (!selectedRow) return;
    setPatchLoading(true);
    try {
      const campos = [];
      if (camposSeleccionados.copiaDNI) campos.push("CopiaDNI");
      if (camposSeleccionados.copiaConstancia) campos.push("CopiaConstancia");
      const camposString = campos.join(",");

      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      // const idUser = sessi.sessionData.id;

      /*const requestBody = {
            Observacion: observacion, // Usa el estado en lugar de un texto fijo
            campos: camposString, // Ajusta según lo que necesites
            IdSolicitud: idSolicitud,
            //IdUserSG: idUser,
            };*/

      const formData = new FormData();
      formData.append("Observacion", observacion);
      formData.append("Campos", camposString);
      formData.append("IdSolicitud", idSolicitud);

      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex,
      );
      //const url = `http://172.20.7.10:8082/api/ConstanciaPag/Habilitar/Subsanacion/`;
      const url = `${dominio}/api/ConstanciaPag/Habilitar/Subsanacion/`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Error al aprobar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      setOpenDialogSubsanar(false);
      setOpenSuccessDialogSubsanar(true);
    } catch (error) {
      alert("Ocurrió un error al aprobar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogSubsanarClose = () => {
    setOpenSuccessDialogSubsanar(false);
    fetchData();
    setObservacion("");
    setCamposSeleccionados({ copiaDNI: false, copiaConstancia: false });
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleCloseDialogSubsanar = () => {
    setOpenDialogSubsanar(false);
    fetchData();
    setObservacion("");
    setCamposSeleccionados({ copiaDNI: false, copiaConstancia: false });

    setErrorObservacion(false);
    setErrorDocumentos(false);
  };

  //////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////// RECHAZAR

  const handleOpenDialogRechazar = (row) => {
    setSelectedRow(row);
    setOpenDialogRechazar(true);
  };

  // 2. PATCH y dialog de RECHAZAR
  const handleAcceptRechazar = async () => {
    if (!selectedRow) return;
    setPatchLoading(true);
    try {
      const campos = [];

      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow.id_solicitud_constancia;
      // const idUser = sessi.sessionData.id;

      /*const requestBody = {
            Observacion: observacion, // Usa el estado en lugar de un texto fijo
            campos: camposString, // Ajusta según lo que necesites
            IdSolicitud: idSolicitud,
            //IdUserSG: idUser,
            };*/

      const formData = new FormData();
      formData.append("Observacion", observacion);
      formData.append("IdSolicitud", idSolicitud);

      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex,
      );
      //const url = `http://172.20.7.10:8082/api/ConstanciaPag/Cancelar/Solicitud/`;
      const url = `${dominio}/api/ConstanciaPag/Cancelar/Solicitud/`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Error al cancelar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      setOpenDialogRechazar(false);
      setOpenSuccessDialogRechazar(true);
    } catch (error) {
      alert("Ocurrió un error al cancelar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogRechazarClose = () => {
    setOpenSuccessDialogRechazar(false);
    fetchData();
    setObservacion("");
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleCloseDialogRechazar = () => {
    setOpenDialogRechazar(false);
    fetchData();
    setObservacion("");
  };

  //////////////////////////////////////////////////////////////////////////////////////

  const handleClick = (id) => {
    sessi.setVariable("IDsolConstanciaSG", id);
    navigate("/PortalDelParticipante/VerSolicitudConstanciaSG");
  };

  return (
    <div className="container" style={{ marginTop: 10 }}>
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          <h2>
            <b>Lista de Solicitudes de Constancias en INJUPEMP Conectados</b>
          </h2>
        </div>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
            mt: 1,
            justifyContent: "center", // <--- Cambia aquí
          }}
        >
          <FormControl size="small" sx={{ minWidth: 170 }}>
            <FormHelperText>Filtrar Constancias:</FormHelperText>
            <Select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setPage(0);
              }}
              displayEmpty
              fullWidth
            >
              <MenuItem value="6">Pendiente de Aprobar</MenuItem>
              <MenuItem value="1">Pendiente de Pago</MenuItem>
              <MenuItem value="2">Pagadas</MenuItem>
              <MenuItem value="4">Emitida</MenuItem>
              <MenuItem value="3">Canceladas</MenuItem>
              <MenuItem value="5">Anuladas</MenuItem>
            </Select>
          </FormControl>
          <Tooltip
            title={
              filteredRows.length
                ? "Descargar bandeja actual en Excel"
                : "No hay datos para exportar"
            }
            arrow
          >
            <span>
              <Button
                variant="contained"
                color="success"
                startIcon={<FileDownloadIcon />}
                onClick={handleDownloadExcel}
                disabled={loading || filteredRows.length === 0}
                sx={{ alignSelf: "flex-end", mb: "3px" }}
              >
                Descargar Excel
              </Button>
            </span>
          </Tooltip>
        </Box>

        <div className="row" style={{ marginTop: "20px" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>#</StyledTableCell>
                  <StyledTableCell>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <strong>DNI Solicitante</strong>
                      <Tooltip title="Buscar por DNI" arrow>
                        <IconButton
                          onClick={(event) =>
                            handleFilterClick(event, "searchDNI")
                          }
                          color={searchDNI ? "primary" : "default"}
                        >
                          <ManageSearchIcon
                            style={{
                              color: searchDNI ? "#1976d2" : "white",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                      {/* {searchDNI && (
                        <Chip
                          label={`DNI: ${searchDNI}`}
                          size="small"
                          onDelete={() => setSearchDNI("")}
                          sx={{ ml: 1, height: 24 }}
                        />
                      )} */}
                    </div>
                  </StyledTableCell>
                  <StyledTableCell>Solicitante</StyledTableCell>
                  <StyledTableCell>Nº Recibo</StyledTableCell>
                  <StyledTableCell>Tipo Constancia</StyledTableCell>
                  <StyledTableCell>Monto</StyledTableCell>
                  <StyledTableCell>Estado</StyledTableCell>
                  <StyledTableCell>Fecha Registro</StyledTableCell>
                  <StyledTableCell>Detalle Solicitud</StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Acciones
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                sx={{
                  p: 2,
                  "& .MuiTextField-root": {
                    m: 1,
                    width: "250px",
                  },
                }}
              >
                {filterType === "searchDNI" && (
                  <Box sx={{ p: 2 }}>
                    <TextField
                      placeholder="Buscar por DNI"
                      aria-label="Buscar por DNI"
                      value={searchDNI}
                      onChange={handleSearchDNIChange}
                      autoFocus
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        size="small"
                        onClick={() => setSearchDNI("")}
                        disabled={!searchDNI}
                      >
                        Limpiar
                      </Button>
                    </Box>
                  </Box>
                )}
              </Popover>

              <TableBody>
                {loading ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      <CircularProgress size={24} />
                    </StyledTableCell>
                  </StyledTableRow>
                ) : filteredRows && filteredRows.length > 0 ? (
                  filteredRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <StyledTableRow key={row.id_solicitud_constancia}>
                        <StyledTableCell>
                          {page * rowsPerPage + idx + 1}
                        </StyledTableCell>
                        <StyledTableCell>{row.DNI_usuario}</StyledTableCell>
                        <StyledTableCell>
                          {row.NombreCompleto_usuario}
                        </StyledTableCell>
                        <StyledTableCell>{row.numero_recibo}</StyledTableCell>
                        <StyledTableCell>
                          {tiposConstancia[row.fk_id_constancia] ||
                            "DESCONOCIDO"}
                        </StyledTableCell>
                        <StyledTableCell>L.{row.monto}</StyledTableCell>
                        <StyledTableCell>
                          {estadosConstancia[row.fk_id_estado] || "DESCONOCIDO"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.fecha_registro
                            ? row.fecha_registro.split("T")[0] +
                              " " +
                              row.fecha_registro.split("T")[1].substring(0, 8)
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.detalle_solicitud}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box display="flex" justifyContent="center">
                            <Tooltip
                              title="Ver Solicitud"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() =>
                                  handleClick(row.id_solicitud_constancia)
                                }
                              >
                                <VisibilityIcon
                                  sx={{ color: "green", fontSize: 30 }}
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title="Aceptar Solicitud"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() => handleOpenDialog(row)}
                                disabled={
                                  patchLoading || row.fk_id_estado !== 6
                                }
                              >
                                <CheckCircleIcon
                                  sx={{
                                    color:
                                      row.fk_id_estado === 6 ? "green" : "grey",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>

                            <Tooltip
                              title="Enviar a Subsanar Solicitud"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() => handleOpenDialogSubsanar(row)}
                                disabled={
                                  patchLoading ||
                                  (row.fk_id_estado !== 6 &&
                                    row.fk_id_estado !== 2)
                                }
                              >
                                <HandymanIcon
                                  sx={{
                                    color:
                                      row.fk_id_estado === 6
                                        ? "green"
                                        : row.fk_id_estado === 2
                                          ? "green"
                                          : "grey",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>

                            <Tooltip
                              title="Rechazar Solicitud"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() => handleOpenDialogRechazar(row)}
                                disabled={
                                  patchLoading || row.fk_id_estado !== 6
                                }
                              >
                                <DeleteIcon
                                  sx={{
                                    color:
                                      row.fk_id_estado === 6 ? "Red" : "grey",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      No hay datos.
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            labelRowsPerPage={"Filas por página"}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle textAlign={"center"}>Confirmar Aceptación</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Está seguro de aceptar la Constancia{" "}
              <b>
                {selectedRow &&
                  tiposConstancia[selectedRow.fk_id_constancia]}{" "}
              </b>
              con N° de recibo <b>{selectedRow && selectedRow.numero_recibo}</b>{" "}
              {selectedRow &&
                (selectedRow.monto === "0.00"
                  ? "para proceder con la siguiente etapa?"
                  : "para proceder con el pago?")}
            </DialogContentText>
            <TextField
              multiline
              rows={3}
              margin="dense"
              label="Observación (opcional)"
              type="text"
              fullWidth
              variant="outlined"
              value={observacionFiltro}
              onChange={(e) => setObservacionFiltro(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialog}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAccept}
              color="primary"
              variant="contained"
              disabled={patchLoading}
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog open={openSuccessDialog} onClose={handleSuccessDialogClose}>
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Aprobada</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La constancia ha sido <strong>Aprobada exitosamente</strong> y ha
              avanzado a la siguiente etapa.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG PARA SUBSANAR */}
        <Dialog
          open={openDialogSubsanar}
          onClose={() => setOpenDialogSubsanar(false)}
        >
          <DialogTitle textAlign={"center"}>Enviar a Subsanar</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Confirmar que desea enviar a <b>subsanación</b> la constancia{" "}
              <b>
                {selectedRow &&
                  tiposConstancia[selectedRow.fk_id_constancia]}{" "}
              </b>
              con N° de recibo <b>{selectedRow && selectedRow.numero_recibo}</b>{" "}
              del solicitante{" "}
              <b>{selectedRow && selectedRow.NombreCompleto_usuario}</b>?
            </DialogContentText>
            <TextField
              multiline
              rows={4}
              autoFocus
              margin="dense"
              label="Observación"
              type="text"
              fullWidth
              variant="outlined"
              value={observacion} // Estado para almacenar la observación
              onChange={(e) => setObservacion(e.target.value)}
              error={errorObservacion}
              helperText={
                errorObservacion ? "La observación es obligatoria" : ""
              }
              required // Hacer obligatorio
            />
            <FormControl
              component="fieldset"
              sx={{ mt: 2 }}
              error={errorDocumentos}
            >
              <FormLabel component="legend">Documentos a Subsanar:</FormLabel>
              <Box
                sx={{
                  border: errorDocumentos
                    ? "1px solid #d32f2f"
                    : "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: 1,
                  p: 2,
                  backgroundColor: errorDocumentos ? "#fff5f5" : "transparent",
                }}
              >
                <FormGroup required>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={camposSeleccionados.copiaDNI}
                        onChange={(e) => {
                          setCamposSeleccionados({
                            ...camposSeleccionados,
                            copiaDNI: e.target.checked,
                          });
                        }}
                      />
                    }
                    label="Copia de DNI"
                  />
                  {selectedRow?.fk_id_constancia != 1 ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={camposSeleccionados.copiaConstancia}
                          onChange={(e) => {
                            setCamposSeleccionados({
                              ...camposSeleccionados,
                              copiaConstancia: e.target.checked,
                            });
                          }}
                        />
                      }
                      label="Copia de Constancia"
                    />
                  ) : null}
                </FormGroup>
              </Box>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialogSubsanar}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAcceptSubsanar}
              color="primary"
              variant="contained"
              disabled={errorObservacion || errorDocumentos}
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog
          open={openSuccessDialogSubsanar}
          onClose={handleSuccessDialogSubsanarClose}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Enviada</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia se envío a Subsanar con éxito y fue
              enviada al participante.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogSubsanarClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG PARA RECHAZAR */}
        <Dialog
          open={openDialogRechazar}
          onClose={() => setOpenDialogRechazar(false)}
        >
          <DialogTitle textAlign={"center"}>Rechazar Solicitud</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Está seguro que desea <b>rechazar</b> la Constancia{" "}
              <b>
                {selectedRow &&
                  tiposConstancia[selectedRow.fk_id_constancia]}{" "}
              </b>
              con N° de recibo <b>{selectedRow && selectedRow.numero_recibo}</b>{" "}
              del solicitante{" "}
              <b>{selectedRow && selectedRow.NombreCompleto_usuario}</b>?
            </DialogContentText>
            <TextField
              multiline
              rows={4}
              autoFocus
              margin="dense"
              label="Observación"
              type="text"
              fullWidth
              variant="outlined"
              value={observacion} // Estado para almacenar la observación
              onChange={(e) => setObservacion(e.target.value)}
              error={!observacion}
              helperText={!observacion ? "La observación es obligatoria" : ""}
              required // Hacer obligatorio
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialogRechazar}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAcceptRechazar}
              color="primary"
              variant="contained"
              disabled={!observacion}
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog
          open={openSuccessDialogRechazar}
          onClose={handleSuccessDialogRechazarClose}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Cancelada</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia se cancelo con éxito.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogRechazarClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </div>
  );
}

export default ListaSolConstanciasSG;
